(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kw-produktinhalt"] && !Shopify.designMode) return;
  try {
    // Medien laden erst, wenn sie aufgeklappt werden: Das iframe steckt bis dahin
  // in einem <template> und baut keine Verbindung zum Anbieter auf.
  document.addEventListener(
    'toggle',
    (event) => {
      const medium = event.target;
      if (!(medium instanceof HTMLDetailsElement) || !medium.open) return;
      if (!medium.matches('[data-kw-medium]')) return;
      const vorlage = medium.querySelector('template');
      if (vorlage) vorlage.replaceWith(vorlage.content.cloneNode(true));
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
